import React, { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import { Shield } from 'lucide-react';
import Logo from '../../components/Logo';

const AdminAuth = () => {
  const { login } = useAdmin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await login({ username, password });
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4 bg-[#050505] text-[#e6e6e6] font-mono">
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]" style={{
        backgroundImage: 'linear-gradient(#22c55e 1px, transparent 1px), linear-gradient(90deg, #22c55e 1px, transparent 1px)',
        backgroundSize: '32px 32px',
      }} />
      <div className="relative w-full max-w-[420px] border border-[#1f1f1f] bg-[#0a0a0a] p-8 rounded-md">
        <div className="mb-6 flex items-center gap-2">
          <Logo size={20} textSize={13} />
          <span className="text-[#22c55e] text-[10px] tracking-[0.25em] ml-1">· ADMIN</span>
        </div>

        <h1 className="text-2xl font-semibold mb-2">Owner Login</h1>
        <p className="text-[13px] text-[#8a8a8a] leading-relaxed mb-6">Only authorized. All actions are logged.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[10px] tracking-[0.2em] text-[#8a8a8a] mb-1.5">USERNAME</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="admin"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.2em] text-[#8a8a8a] mb-1.5">PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          {err && <p className="text-[12px] text-red-400">{err}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 rounded-md text-xs tracking-[0.2em] bg-[#166534] hover:bg-[#15803d] disabled:opacity-50 text-[#e7ffef] transition-colors"
          >
            {loading ? 'PLEASE WAIT…' : 'LOGIN AS ADMIN'}
          </button>
        </form>

        <div className="mt-6 pt-4 border-t border-[#1f1f1f] flex items-center justify-between text-[10px] tracking-[0.2em] text-[#5a5a5a]">
          <a href="/" className="hover:text-[#22c55e]">← STORE</a>
          <span>V1.4.2</span>
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;
